import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  ContentEventBatch,
  ContentFeedParams,
  ContentItem,
  ContentReactionType,
} from '@/types/content';

// SPEC-021: Student-side content API. All routes enforce the audience +
// tier gate server-side, so the client only forwards the user's filters.

function params(p?: ContentFeedParams): Record<string, string> {
  if (!p) return {};
  const out: Record<string, string> = {};
  if (p.type) out.type = p.type;
  if (p.tag_id) out.tag_id = p.tag_id;
  if (p.bookmarked) out.bookmarked = 'true';
  return out;
}

export async function listContentFeed(p?: ContentFeedParams): Promise<ContentItem[]> {
  const { data } = await client.get<ApiResponse<ContentItem[]>>('/api/v1/content/feed', {
    params: params(p),
  });
  return data.data ?? [];
}

export async function getContentForView(id: string): Promise<ContentItem> {
  const { data } = await client.get<ApiResponse<ContentItem>>(
    `/api/v1/content/${id}/view`,
  );
  return data.data;
}

export async function ingestEvents(
  id: string,
  batch: ContentEventBatch,
): Promise<void> {
  await client.post(`/api/v1/content/${id}/events`, batch);
}

export async function addReaction(
  id: string,
  reaction_type: ContentReactionType,
): Promise<void> {
  await client.post(`/api/v1/content/${id}/reactions`, { reaction_type });
}

export async function removeReaction(
  id: string,
  reaction_type: ContentReactionType,
): Promise<void> {
  await client.delete(`/api/v1/content/${id}/reactions/${reaction_type}`);
}
